export const contactUs = [
  {
    id: '1',
    name: 'HARDEEP S. PURI',
    designation: 'Hon’ble Minister of State (Independent charge)',
    epabx: '--',
    hotline: '250',
    contact: '23063495, 23061162, 23061166, 23062089 (Fax)',
    email: 'minister-mohua@nic.in',
    room: '104-C',
    residence: '21410761, 21410773',
  },
  {
    id: '2',
    name: 'S.K. VALIATHAN',
    designation: 'Deputy Secretary/PS to Minister',
    epabx: '2302',
    hotline: '211',
    contact: '23063495, 23061232 | New: 23063513, 23063024, 23061661',
    email: 'pstomin-mohua@gov.in',
    room: '105-C',
    residence: '--',
  },
];

// Scientist Directory Data
export const ncmrwfHead = [
  {
    srNo: 1,
    name: 'Dr. V.S Prasad',
    designation: 'Director/Head & Scientist-G',
    email: 'vsprasad',
    directNo: '2419401',
    ext: '401',
  },
  {
    srNo: 2,
    name: 'Mohit Sharma',
    designation: 'Jr. Assistant',
    email: 'mohit',
    directNo: '2419483',
    ext: '483',
  },
  {
    srNo: 3,
    name: 'Mr. Rajkumar II',
    designation: 'MTS',
    email: '',
    directNo: '2419483',
    ext: '483',
  },
];

export const columnsContactUs = [
  { header: 'Sr No', accessor: 'srNo' },
  { header: 'Name', accessor: 'name' },
  { header: 'Designation', accessor: 'designation' },
  { header: 'Email ID', accessor: 'email' },
  { header: 'Direct No', accessor: 'directNo' },
  { header: 'Ext', accessor: 'ext' },
];
